import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { store } from "./store";

import { InertiaProgress } from "@inertiajs/progress";
import VCalendar from "v-calendar";

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });

    app.config.globalProperties.$route = (urlName, params = undefined) => {
      return window.route(urlName, params, undefined, Ziggy);
    };

    app.use(plugin);
    app.use(VCalendar, {});

    app.use(store);
    app.mount(el);
  },
});

InertiaProgress.init();
